import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex align-items-center" }
const _hoisted_2 = { class: "caption text-info" }

import { useI18n } from 'vue-i18n';
import TooltipIcon from '@/components/tooltip/TooltipIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenNoBridgeLabel',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('wrappedContract.tokenOnChain.caption', { chain: 'Milkomeda' })), 1),
    _createVNode(TooltipIcon, {
      color: "info",
      tooltip: _unref(t)('wrappedContract.tokenOnChain.tooltip', { chain: 'Milkomeda' })
    }, null, 8, ["tooltip"])
  ]))
}
}

})